import { connect } from 'react-redux';
import TopIcons from './top_icons';
import { authPendingAction, displayRegister } from '../../../actions/auth';
import { displayNotifyMe } from '../../../actions/notify_me';
import withPGTranslation from '../../../config/withPGTranslation';

export default connect(
  null,
  {
    authPendingAction,
    displayRegister,
    displayNotifyMe
  }
)(withPGTranslation(TopIcons));
